import { forwardRef } from "react";
import { useI18n, Locale } from "@/lib/i18n";
import { useCountry } from "@/lib/countryContext";
import { getCountryByCode } from "@/lib/countries";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const LOCALE_TO_COUNTRY: Record<string, string> = {
  sv: "SE", no: "NO", da: "DK", fi: "FI", de: "DE", en: "GB",
};

const LanguageSelector = forwardRef<HTMLButtonElement>((_, ref) => {
  const { locale, setLocale, locales } = useI18n();
  const { setCountry } = useCountry();

  const handleChange = (v: string) => {
    setLocale(v as Locale);
    const countryCode = LOCALE_TO_COUNTRY[v];
    if (countryCode) {
      const found = getCountryByCode(countryCode);
      if (found) setCountry(found);
    }
  };

  return (
    <Select value={locale} onValueChange={handleChange}>
      <SelectTrigger ref={ref} className="w-auto min-w-[60px] h-8 text-xs gap-1 border-border bg-card">
        <SelectValue>
          <span className="flex items-center gap-1.5">
            <span>{locales.find((l) => l.code === locale)?.flag}</span>
            <span className="hidden sm:inline">{locales.find((l) => l.code === locale)?.name}</span>
          </span>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {locales.map((l) => (
          <SelectItem key={l.code} value={l.code}>
            <span className="flex items-center gap-2">
              <span>{l.flag}</span>
              <span>{l.name}</span>
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
});

LanguageSelector.displayName = "LanguageSelector";

export default LanguageSelector;
